import { useQuery } from '@tanstack/react-query';
import { fetchTags } from '@/api/client';
import type { LanguageCode } from '@/types';

export function useTags(lang: LanguageCode) {
  return useQuery({
    queryKey: ['tags', lang],
    queryFn: () => fetchTags(lang),
  });
}
